// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockOptionSubject_wrapper__L6H5e","title":"BlockOptionSubject_title__AlQCn"};